export { default as Aditivos } from "./Aditivos"
export { default as AditivosEditForm } from "./AditivosEditForm"
export { default as AditivosCreateForm } from "./AditivosCreateForm"
export { default as TableAditivos } from "./TableAditivos"
export { default as AditivosTrash } from "./AditivosTrash"
export { default as TableAditivosTrash } from "./TableAditivosTrash"



// WEBPACK FOOTER //
// ./src/views/contratos/aditivos/index.js